import React from "react";

import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";


function JobPlanButton({ id, status, isAppraiser = false }) {
    let label = "View";
    let color = "neutral";
    let textColor = "rgba(0,0,0,0.7)";

    switch (status) {
        case "draft":
        case "open":
            if (!isAppraiser) {
                label = "Continue";
                color = "primary";
                textColor = "rgb(255.255.255)";
            }
            break;

        case "awaiting_approval":
            if (isAppraiser) {
                label = "Review";
                color = "primary";
                textColor = "rgb(255.255.255)";
            }
            break;

        case "review":
            if (isAppraiser) {
                label = "Review";
                color = "primary";
                textColor = "rgb(255.255.255)";
            }
            break;

        default:
            break;
    }

    return (
        <Button
            variant="contained"
            color={color}
            disableElevation={true}
            aria-label="Survey"
            component={Link}
            to={`/jp/jobplans/${Number(id) || ""}`}
            endIcon={<KeyboardArrowRightOutlinedIcon />}
        >
            <Typography variant="span" sx={{ color: textColor }}>
                {label}
            </Typography>
        </Button>
    );
}

export default JobPlanButton;
